import { initialState } from 'redux/initialState'

export default () => ({ ...initialState, authenticated: false })
